import { Typography } from '@mui/material';
import type { Account } from '@repo/api-gw-sdk';
import { useEffect, useState } from 'react';

import { useDAL } from '@/contexts/useDAL';

export const RestoreAccountConfiguration = ({
  account,
}: {
  account: Account;
}) => {
  const dal = useDAL();

  // this will be changed with the new UI, as we won't have one column indication for multiple props.
  // today this custom indicate if there is a change in both tags and network.
  const [isDefault, setIsDefault] = useState(true);
  useEffect(() => {
    dal.cloudAccounts.restore.configuration
      .get(account.id)
      .then((config) => {
        const changedVpcConfigs =
          config.restoreAccountConfig.config.aws?.vpcConfigs;
        setIsDefault(!changedVpcConfigs || changedVpcConfigs.length === 0);
      })
      .catch(() => {
        setIsDefault(true);
      });
  }, [account.id, setIsDefault, dal.cloudAccounts.restore.configuration]);

  return <Typography>{isDefault ? 'Default' : 'Custom'}</Typography>;
};
